<template>
<div class="chapter">
<div class="inner_page">
<div class="ad">
<p class="center"><a href="https://murder-mayhem.com/newsletters/?utm_source=MNMGOAAAAI&amp;utm_campaign=9781504091527" target="_blank">
<img alt="image" src="xhtml/mm-backad.jpg"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mm.vue?5aa2114e